import {KeyboardEvent, useState} from 'react';

import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';
import {FlexCenterVertically} from '~/shared/theme/FlexLayout';
import {OrderWithMenuVisibility} from '~/shared/store/models/User/UserReport';
import {mapTranslate} from '~/shared/consts/userTransactionsConsts';
import {Arrow as _Arrow} from '~/shared/components/UserTransactions/components/CustomTable/CellRenderer';

import ChildHeadRow from './ChildHeadRow';
import ChildPayments, {ChildTableRow} from './ChildPayments';
import {ArrowCell, Cell, ExpandableContent} from './common';
import MenuCell from './MenuCell';

const RestaurantNameCell = styled(Cell)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Arrow = styled(_Arrow)`
  path {
    fill: ${({theme}) => theme.colors.contentDefault};
  }
`;

const ChildBodyTable = ({items, menuEvents}: {items?: OrderWithMenuVisibility[]; menuEvents: any}) => {
  const {t} = getLocalizationService();
  const [openRowIds, setOpenRowIds] = useState<OrderWithMenuVisibility['orderId'][]>(() => items?.map(item => item.orderId as number) ?? []);

  const toggleRow = (id: number) => {
    if (openRowIds?.includes(id)) {
      setOpenRowIds(openRowIds.filter(_id => _id !== id));
      return;
    }

    setOpenRowIds([...openRowIds, id]);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>, id: number) => {
    if (e.code === 'Enter') {
      toggleRow(id);
    }
  };

  if (!items) {
    return null;
  }

  return (
    <>
      <ChildHeadRow />

      {items?.map((item, index) => {
        const isOpen = openRowIds.includes(item.orderId as number);
        return (
          <ExpandableContent key={item.orderId} noBorder={index === items.length - 1}>
            <ChildTableRow
              tabIndex={0}
              isOpen={isOpen}
              onKeyDown={e => handleKeyDown(e, item.orderId as number)}
              onClick={() => toggleRow(item.orderId as number)}
            >
              <FlexCenterVertically>
                <ArrowCell>
                  <Arrow $facedown={isOpen} />
                </ArrowCell>
                <Cell width={120}>{item.orderTimeStr}</Cell>
                <RestaurantNameCell width={300}>{item.restaurantName}</RestaurantNameCell>
                <Cell width={110}>
                  {t(mapTranslate[item.orderType as keyof typeof mapTranslate] || item.orderType)}
                </Cell>
              </FlexCenterVertically>
              <MenuCell order={item} menuEvents={menuEvents} />
            </ChildTableRow>

            {isOpen && <ChildPayments payments={item.payments} orderTypeOrigin={item.orderType} discount={item.discount} />}
          </ExpandableContent>
        );
      })}
    </>
  );
};
export default ChildBodyTable;
